export default {
	methods: {
		customFormatNumber(number) {
			if (!number) return ''
			const parts = number?.toString()?.split('.')
			parts[0] = parts[0]?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
			const value = parts?.join('.')
			return value
		}
	}
}